export class Database {
  public static assets: any[];

  public static games: any[] = [
    {
      id: 'matcha-adventure',
      name: 'Matcha Adventure',
      image: 'game-matcha-adventure.png',
      description: 'Embark on a magical gem-smashing journey!',
      developer: true,
      tournaments: false
    },
    {
      id: 'matcha-blitz',
      name: 'Matcha Blitz',
      image: 'game-matcha-blitz.png',
      description: 'Compete in fast gem-smashing action!',
      tournaments: true
    },
    {
      id: 'solitaire',
      name: 'Solitaire',
      image: 'game-solitaire.png',
      description: 'Klondike solitaire with competitive scoring!',
      tournaments: true
    },
    {
      id: 'whacka',
      name: 'Whacka',
      image: 'game-whacka.png',
      description: 'The favorite Midway game, now with UFOs!',
      tournaments: true
    }
  ];

  public static getAsset(id:string): any {
    return Database.assets.find(a => a.id == id);
  }

  public static getGame(id:string): any {
    return Database.games.find(g => g.id == id);
  }

  public static getAssetsByCategory(category:string): any[] {
    let assets = [];
    for(let i = 0; i < Database.assets.length; i++) 
      if(Database.assets[i].category == category)
        assets.push(Database.assets[i]);
    return assets;
  }

  public static getAssetsByType(type:string): any[] {
    let assets = [];
    for(let i = 0; i < Database.assets.length; i++) 
      if(Database.assets[i].type == type)
        assets.push(Database.assets[i]);
    return assets;
  }

  public static getAssetsByTypeAndCategory(type:string, category:string): any[] {
    let assets = [];
    for(let i = 0; i < Database.assets.length; i++) 
      if(Database.assets[i].type == type)
        if(Database.assets[i].category == category)
          assets.push(Database.assets[i]);
    return assets;
  }

  public static getTournamentCost(gameId:string) {
    if(gameId == 'matcha-blitz') return 10;
    if(gameId == 'solitaire') return 25;
    if(gameId == 'whacka') return 8;
    return 10;
  }
}